import { render } from "./addpayment.vue?vue&type=template&id=1a05b3c5"
import script from "./addpayment.vue?vue&type=script&lang=js"
export * from "./addpayment.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zonegoh/Documents/GitHub/level-up/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__